import React from 'react';
import { ratingTypes } from '../../../../utils/constants';
import styles from '../../search.scss';

const UtrFitFilter = props => {
    const { filterInputs, handleUtrFitPositionChange, handleUtrFitRatingChange, 'data-testid': dataTestId } = props;
    const utrFitPositions = [
        { value: '1', label: 'Top 1' },
        { value: '2', label: 'Top 2' },
        { value: '3', label: 'Top 3' },
        { value: '4', label: 'Top 4' },
        { value: '5', label: 'Top 5' },
        { value: '6', label: 'Top 6' },
    ];

    return (
        <>
            <div className={styles.searchFilterInputLabel} data-testid={dataTestId && `${dataTestId}.rating-label`}>Enter your {ratingTypes.tennis}</div>
            <div className="row">
                <div className="col">
                    <input
                        className="form-control"
                        value={filterInputs.utrFitRating}
                        onChange={handleUtrFitRatingChange}
                        data-testid={dataTestId && `${dataTestId}.rating-input`}
                    />
                </div>
            </div>
            <div className={`${styles.searchFilterInputLabel} mt16`} data-testid={dataTestId && `${dataTestId}.position-label`}>Select lineup range</div>
            <div className="row">
                <div className="col">
                    <select
                        className="form-control"
                        value={filterInputs.utrFitPosition}
                        onChange={(e) => handleUtrFitPositionChange(e.target.value)}
                        data-testid={dataTestId && `${dataTestId}.position-select`}
                    >
                        {utrFitPositions.map(option => <option value={option.value} key={option.value}>{option.label}</option>)}
                    </select>
                </div>
            </div>
        </>
    );
};

export default UtrFitFilter;
